import React from "react";
import { Link } from "react-router-dom";

import { Breadcrumb, BreadcrumbItem } from "reactstrap"; // Assuming you are using reactstrap

const Breadcrumbs = ({ items }) => {
  return (
    <>
      <Breadcrumb>
        {items.map((item, index) => (
          <BreadcrumbItem key={index} active={index === items.length - 1}>
            {item.link ? (
              <Link to={item.link}>{item.title}</Link>
            ) : (
              <span className="text-secondary">{item.title}</span>
            )}
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </>
  );
};

export default Breadcrumbs;
